import { z } from 'zod';
export type PublicSiteImageInput = {
  key: string;
  name: string;
  role?: 'photo' | 'reference';
};
export type PublicSiteIntent =
  | {
      action: 'changes';
      request: string;
      operationKey: string;
      images?: PublicSiteImageInput[];
    }
  | { action: 'publish'; selectedVersion: string }
  | { action: 'retry' | 'sync' };
const changeBody = z
  .object({
    prompt: z.string().trim().min(1).max(8000),
    operationId: z.uuid(),
    images: z
      .array(
        z
          .object({
            key: z.string().max(512),
            name: z.string().trim().min(1).max(200),
            role: z.enum(['photo', 'reference']).optional(),
          })
          .strict()
      )
      .max(8)
      .optional(),
  })
  .strict();
const publishBody = z.object({ versionId: z.uuid() }).strict();
export function buildPublicSitePayload(intent: PublicSiteIntent) {
  switch (intent.action) {
    case 'changes':
      return changeBody.parse({
        prompt: intent.request,
        operationId: intent.operationKey,
        ...(intent.images?.length ? { images: intent.images } : {}),
      });
    case 'publish':
      return publishBody.parse({ versionId: intent.selectedVersion });
    default:
      return {};
  }
}
